import pad from "./signature-pad";
import {loader} from "./loader";

export default function studentAdmission() {
  let im_input = $("#sign-image");
  let im_input_raw = $("#sign-image-raw");
  let si = window.admission_form.sign_image_raw;

  if (si && si !== '') {
    si = JSON.parse(si);
    im_input_raw.val(si);
  } else {
    si = undefined;
  }
  const signaturePad = pad(si, im_input_raw)

  const edata = window.admission_form.admission_emergency;
  if (edata !== undefined && Object.keys(edata).length > 0) {
    Object.keys(edata).forEach(function (index) {
      const c = edata[index];
      $('#emergency-contacts').append(getEmergencyContactTemplate(parseInt(index, 10)));
      increaseEmergencyContactCount();

      if (typeof c === 'object') {
        $('input[name="admission_emergency['+index+'][first_name]"]').val(c.first_name);
        $('input[name="admission_emergency['+index+'][last_name]"]').val(c.last_name);
        $('input[name="admission_emergency['+index+'][relation]"]').val(c.relation);
        $('input[name="admission_emergency['+index+'][address]"]').val(c.address);
        $('input[name="admission_emergency['+index+'][email]"]').val(c.email);
        $('input[name="admission_emergency['+index+'][phone_number]"]').val(c.phone_number);
      }
    })
  } else {
    $('#emergency-contacts').append(getEmergencyContactTemplate(1));
  }
  function getEmergencyContactTemplate (i = 0) {
    const is_required = (i === 1) ? '<span class="required">*</span>' : '';
    const is_required_class = (i === 1) ? 'required' : '';
    const show_remove = (i !== 1) ? '<div class="col-12"><a href="#" class="remove-emergency-contact" style="color: #2ba1c6; font-size: 14px;">Remove</a></div>' : '';
    const show_hr = (i !== 1) ? '<div class="col-12"><hr style="margin-top: 0;" /></div>' : '';
    return `
      <div class="form-row">
          ${show_hr}
          <div class="form-group col-md-4 ${is_required_class}">
              <label for="admission_emergency[${i}][first_name]">First name ${is_required}</label>
              <input type="text" class="form-control" name="admission_emergency[${i}][first_name]" value="">
          </div>
          <div class="form-group col-md-4 ${is_required_class}">
              <label for="admission_emergency[${i}][last_name]">Last name ${is_required}</label>
              <input type="text" class="form-control" name="admission_emergency[${i}][last_name]" value="">
          </div>
          <div class="form-group col-md-4 ${is_required_class}">
              <label for="admission_emergency[${i}][relation]">Relationship to applicant ${is_required}</label>
              <input type="text" class="form-control" name="admission_emergency[${i}][relation]" value="">
          </div>
          <div class="form-group col-md-4">
              <label for="admission_emergency[${i}][address]">Home Address (If Different)</label>
              <input type="text" class="form-control" name="admission_emergency[${i}][address]" value="">
          </div>
          <div class="form-group col-md-4 ${is_required_class}">
              <label for="admission_emergency[${i}][email]">Email ${is_required}</label>
              <input type="email" class="form-control" name="admission_emergency[${i}][email]" value="">
          </div>
          <div class="form-group col-md-4 ${is_required_class}">
              <label for="admission_emergency[${i}][phone_number]">Phone Number ${is_required}</label>
              <input type="text" class="form-control" name="admission_emergency[${i}][phone_number]" value="">
          </div>
          ${show_remove}
      </div>
    `;
  }
  function increaseEmergencyContactCount () {
    var c = parseInt($('#emergency-contacts').data('count')) + 1;
    $('#emergency-contacts').data('count', c);
  }
  function checkForRequiredEmergencyContactFields() {
    let status = 1;
    $('.form-group.required input').each(function (ind, el){
      if ($(el).val() === ''){
        status = 0;
        $(el).parents('.form-group').append('<span class="form-error">Value is required</span>');
      }
    })
    return status;
  }
  $('#add-emergency-contact').on('click', function (e) {
    e.preventDefault();
    increaseEmergencyContactCount();
    const ct = $('#emergency-contacts').data('count');
    $('#emergency-contacts').append(getEmergencyContactTemplate(parseInt(ct, 10)));
  });
  $('#emergency-contacts').on('click', '.remove-emergency-contact', function (e) {
    e.preventDefault();
    $(this).parents('.form-row').remove();
    $('#emergency-contacts').data('count', parseInt($('#emergency-contacts').data('count')) - 1);
  })
  $('#admission-form').submit(function (e) {
    e.preventDefault();
    loader.show();
    $('.form-error').remove();

    const dataURL = signaturePad.toDataURL('image/svg+xml');
    const rawDataURL = JSON.stringify(signaturePad.toData());
    im_input.val(dataURL);
    im_input_raw.val(rawDataURL);

    const status = checkForRequiredEmergencyContactFields();
    if (status === 0) {
      loader.hide();
      $('html, body').animate({ scrollTop: 0}, 200, 'linear')
      return false;
    }

    if (im_input_raw.val() === '[]'){
      $('.signature-pad--actions').append('<span class="form-error">Sign is required</span>');
      loader.hide();
      return false;
    }

    const rules = $("input[name='admission_rules_agreed']");
    if (rules.prop( "checked" ) === false) {
      rules.parents('.form-group').append('<span class="form-error">Value is required</span>');
      loader.hide();
      return false;
    }

    this.submit();
  })
}